import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography } from "@material-ui/core";
import { Challenge, ChallengeMetaType } from "api/admin/challenges";
import { formattedDate } from "utils/helpers";
import i18n from "./i18n";

interface ChallengeDetailDialogProps {
    challengeData: Challenge | undefined,
    show: boolean,
    onClose: () => void,
}

// filter bookings dialog
const ChallengeDetailDialog = ({ challengeData, show, onClose }: ChallengeDetailDialogProps) => {
    // render meta row
    const renderMetaRow = (label: string, content: React.ReactNode) => (
        <>
            <Grid item xs={6} md={3} lg={3}>
                <Typography variant="subtitle2">{label}</Typography>
            </Grid>
            <Grid item xs={6} md={9} lg={9}>
                {content}
            </Grid>
        </>
    );
    // render
    return (
        <Dialog
            fullWidth
            open={show}
            onClose={onClose}
        >
            <DialogTitle>{i18n.challengeDetails}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={1}>
                    {renderMetaRow(i18n.title, (
                        <Typography>{challengeData?.challengeName}</Typography>
                    ))}
                    {renderMetaRow(i18n.description, (
                        <Typography>{challengeData?.description}</Typography>
                    ))}
                    {challengeData && renderMetaRow(i18n.startDate, (
                        <Typography>{formattedDate(challengeData.startDate)}</Typography>
                    ))}
                    {challengeData && renderMetaRow(i18n.endDate, (
                        <Typography>{challengeData.endDate ? formattedDate(challengeData.endDate) : i18n.open}</Typography>
                    ))}
                    {renderMetaRow(i18n.sportForm, (
                        <Typography>{challengeData?.sportForm}</Typography>
                    ))}
                    {renderMetaRow(i18n.tags, (
                        <Typography>{challengeData?.tags?.join(", ")}</Typography>
                    ))}
                    {renderMetaRow(i18n.hasRewards, (
                        challengeData?.challengeRewards.map((m) => (<Typography>{`${m?.rewardType} - ${m?.badgeTitle}`}</Typography>))
                    ))}
                    {renderMetaRow(i18n.isBlueprint, (
                        <Typography>{challengeData?.metaType === ChallengeMetaType.BLUEPRINT ? i18n.yes : i18n.no}</Typography>
                    ))}
                    {renderMetaRow(i18n.participants, (
                        <Typography>{challengeData?.numParticipants}</Typography>
                    ))}
                    {renderMetaRow(i18n.minutesPlayed, (
                        <Typography>{challengeData?.numMinutesPlayed}</Typography>
                    ))}
                    {renderMetaRow(i18n.numBookings, (
                        <Typography>{challengeData?.numBookings}</Typography>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    {i18n.cancel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChallengeDetailDialog;
